import { createSelector } from 'reselect';
import {
    get,
    isEqual,
    orderBy
} from 'lodash';
import {
    CSV_FAILURE,
    CSV_LOAD,
    CSV_SUCCESS
} from './csvActions';
import { getEntityByName } from '../appEntities';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case CSV_LOAD:
            newState = {
                ...state,
                shouldDoLargeExport: false,
                csvData: null,
                error: null,
                loading: true
            };

            return isEqual(state, newState) ? state : newState;

        case CSV_SUCCESS:
            newState = {
                ...state,
                loading: false
            };

            if (action.hasMore && (action.tableName === 'Transactions' || action.tableName === 'Chargebacks')) {
                newState.shouldDoLargeExport = true;
            } else {
                const sort = get(action.sorters, '[0]');
                newState.csvData = action.csvData;
                if (sort) {
                    const sortKey = sort.id;
                    const sortDirection = sort.desc ? 'desc' : 'asc';
                    newState.csvData = orderBy(action.csvData, [ sortKey ], [ sortDirection ]);
                }
            }

            return isEqual(state, newState) ? state : newState;

        case CSV_FAILURE:
            newState = {
                ...state,
                loading: false
            };

            if ((get(action, 'error.message') || '').includes('data set too large')) {
                newState.shouldDoLargeExport = true;
            } else {
                newState.shouldDoLargeExport = false;
                newState.error = action.error;
            }

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getCsvEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'csv')
);

export const getIsCsvLoading = createSelector(
    getCsvEntity,
    (entity) => get(entity, 'loading')
);

export const getCsvError = createSelector(
    getCsvEntity,
    (entity) => get(entity, 'error')
);

export const getCsvErrorMessage = createSelector(
    getCsvError,
    (entity) => get(entity, 'message')
);

export const getCsvData = createSelector(
    getCsvEntity,
    (entity) => get(entity, 'csvData')
);

export const getShouldDoLargeExport = createSelector(
    getCsvEntity,
    (entity) => get(entity, 'shouldDoLargeExport')
);
